import { ThemeOptions } from '@mui/material';
import type {} from '@mui/x-date-pickers-pro/themeAugmentation';

import * as MuiDateCalendarConfig from './MuiDateCalendar';
import * as MuiDatePickerConfig from './MuiDatePicker';
import * as MuiDateRangeCalendarConfig from './MuiDateRangeCalendar';
import * as MuiDayCalendarConfig from './MuiDayCalendar';
import * as MuiMultiInputDateRangeFieldConfig from './MuiMultiInputDateRangeField';
import * as MuiPickersLayoutConfig from './MuiPickersLayout';

export type {} from './MuiDateCalendar';
export type {} from './MuiDatePicker';
export type {} from './MuiDateRangeCalendar';
export type {} from './MuiDayCalendar';
export type {} from './MuiMultiInputDateRangeField';
export type {} from './MuiPickersLayout';

export const datePickers: ThemeOptions['components'] = {
  ...MuiDateCalendarConfig,
  ...MuiDatePickerConfig,
  ...MuiPickersLayoutConfig,
  ...MuiDateRangeCalendarConfig,
  ...MuiDayCalendarConfig,
  ...MuiMultiInputDateRangeFieldConfig
};
